import React, { PureComponent } from 'react';
import { LineChart, Line, Legend, Scatter, ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Bar } from 'recharts';

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-45)">
          {payload.value}
        </text>
      </g>
    );
  }
}

export default class GraficaFisico extends PureComponent {

  getDataDefectos(data){
    const primarios = Array.isArray(data?.defectos_primarios) ? data.defectos_primarios : [];
    const secundarios = Array.isArray(data?.defectos_secundarios) ? data.defectos_secundarios : [];
    const defectos = primarios.concat(secundarios);
    let dataDefectos = [];
    for (let d = 0; d < defectos.length; d++) {

      dataDefectos.push(    {
        defecto: defectos[d]?.tipo_mancha?.nombre ?? defectos[d]?.tipo_mancha ?? defectos[d]?.nombre_mancha ?? defectos[d]?.id_tipo_mancha ?? `#${d+1}`,
        defectos: Number(defectos[d]?.defectos ?? 0),
        no_granos: Number(defectos[d]?.no_granos ?? 0)
      });
    }
    console.log(dataDefectos);
    return dataDefectos;
  }

  renderLegend = (props) => {
  const { payload } = props;
  return (
    <div style={{display: 'grid', gridTemplateColumns: 'max-content max-content', gap: '1em'}}>
      {payload.map((entry, index) => (
        <div>entry.value</div>
      ))}
    </div>
  );
}

  render() {
    const { data } = this.props;

    return (
        <div style={{ width: '100%',paddingTop: 80}}>
          <ResponsiveContainer minHeight={250}>
            <ComposedChart
              style={{ width: '100%'}}
              responsive
              data={this.getDataDefectos(data)}
              margin={{
                top: 20,
                right: 0,
                bottom: 50,
                left: 0,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="defecto" tick={<CustomizedAxisTick />} />
              <YAxis />
              <Bar dataKey="no_granos" name="Granos" barSize={20} fill="rgba(109, 130, 15, 1)" />
              <Scatter dataKey="defectos" name="Defectos" fill="#C7AE34" />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
    );
  }
}